export const ENGINES = {
  bidding: {
    title: "Bidding Rules",
  },
  budget: {
    title: "Campaign Rules",
  },
  pricing: {
    title: "Pricing Rules",
  },
  lineitem_bidding: {
    title: "Line Item Bidding Rules",
  },
};
